import { render } from "./ManagerDevicePage.vue?vue&type=template&id=04284a3a&ts=true"
import script from "./ManagerDevicePage.vue?vue&type=script&lang=ts"
export * from "./ManagerDevicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__